export enum ExpenseTag {
  Subscription = "Subscription",
  SubscriptionPlanChange = "SubscriptionPlanChange",
  SubscriptionLicence = "SubscriptionLicence",
  Tax = "Tax",
  Corrective = "Corrective",
  SupportBasic = "SupportBasic",
  SupportAdvanced = "SupportAdvanced",
  SupportCustom = "SupportCustom",
  Ingest = "Ingest",
  Storage = "Storage",
  Order = "Order",
  Share = "Share",
  UserBasic = "UserBasic",
  UserAdmin = "UserAdmin",
  ServiceConfig = "ServiceConfig",
}
